<template>
  <div class="component-block">
    <div class="spin" v-if="loading">
      <LoadingSpinner />
    </div>
    <NavigationView />
    <div class="block-container">
      <div class="tableview-block">
        <div class="tableview-top">
          <div class="tableview-top-left">
            <div class="tableview-top-count">
              Все объекты {{ startLoading ? "" : `(${tableItems.length})` }}
            </div>
            <div class="tableview-top-search pc">
              <label>
                <svg
                  class="tableview-top-search-icon"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.9996 16.94L13.3031 12.2435C14.5231 10.7515 15.1229 8.84761 14.9785 6.92571C14.8341 5.00381 13.9565 3.21094 12.5273 1.91793C11.0981 0.624921 9.22654 -0.0692924 7.29982 -0.0211186C5.37311 0.0270553 3.53862 0.813931 2.1758 2.17675C0.812985 3.53957 0.0261092 5.37406 -0.0220646 7.30077C-0.0702385 9.22748 0.623975 11.099 1.91698 12.5282C3.20999 13.9574 5.00287 14.835 6.92476 14.9794C8.84666 15.1238 10.7505 14.524 12.2426 13.304L16.9391 18.0005L17.9996 16.94ZM7.49959 13.5005C6.3129 13.5005 5.15287 13.1486 4.16617 12.4894C3.17948 11.8301 2.41044 10.893 1.95632 9.79664C1.50219 8.70028 1.38337 7.49388 1.61488 6.33C1.84639 5.16611 2.41784 4.09701 3.25695 3.2579C4.09607 2.41878 5.16516 1.84734 6.32905 1.61583C7.49294 1.38432 8.69934 1.50314 9.79569 1.95726C10.8921 2.41139 11.8291 3.18042 12.4884 4.16712C13.1477 5.15381 13.4996 6.31385 13.4996 7.50054C13.4978 9.09129 12.8651 10.6164 11.7403 11.7412C10.6154 12.866 9.09034 13.4988 7.49959 13.5005Z"
                    fill="#4D5460"
                  />
                </svg>
                <input
                  v-model="searchValue"
                  type="text"
                  placeholder="Найти объект..."
                />
                <button
                  @click="this.searchValue = ''"
                  v-if="searchValue !== ''"
                  class="tableview-top-search-close"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.707 6.70685L17.293 5.29285L12 10.5858L6.70697 5.29285L5.29297 6.70685L10.586 11.9998L5.29297 17.2928L6.70697 18.7068L12 13.4138L17.293 18.7068L18.707 17.2928L13.414 11.9998L18.707 6.70685Z"
                    />
                  </svg>
                </button>
              </label>
            </div>
          </div>
          <div>
            <!-- <button @click="showCreateDialog" class="button-add-transparent pc">
              Добавить объект
            </button> -->
            <button @click="clearFilters" class="clear-filters pc">
              Сбросить фильтры
            </button>
            <button
              @click="showCreateDialog"
              class="button-add-transparent mobile"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M24 11H13V0H11V11H0V13H11V24H13V13H24V11Z" />
              </svg>
            </button>
            <button @click="clearFilters" class="clear-filters mobile">
              <svg
                x="0"
                y="0"
                viewBox="0 0 24 24"
                style="enable-background: new 0 0 512 512"
                xml:space="preserve"
                class=""
              >
                <g>
                  <path
                    d="M19 13a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1 0-1.5h2.5A.75.75 0 0 1 19 13zm2.75 0A4.756 4.756 0 0 1 17 17.75a4.689 4.689 0 0 1-2.25-.593V21a.75.75 0 0 1-1.2.6l-4-3a.75.75 0 0 1-.3-.6v-4a.745.745 0 0 0-.221-.53L3.91 8.35a2.231 2.231 0 0 1-.66-1.59V4.5A2.253 2.253 0 0 1 5.5 2.25h13a2.253 2.253 0 0 1 2.25 2.25v2.26a2.235 2.235 0 0 1-.66 1.591l-.615.614A4.738 4.738 0 0 1 21.75 13zm-8.5 6.5v-3.619a4.7 4.7 0 0 1-1-2.881A4.756 4.756 0 0 1 17 8.25a4.692 4.692 0 0 1 .969.1l1.06-1.061a.745.745 0 0 0 .221-.53V4.5a.751.751 0 0 0-.75-.75h-13a.751.751 0 0 0-.75.75v2.26a.745.745 0 0 0 .221.53l5.119 5.12a2.231 2.231 0 0 1 .66 1.59v3.625zm7-6.5A3.25 3.25 0 1 0 17 16.25 3.254 3.254 0 0 0 20.25 13z"
                    opacity="1"
                    data-original="#000000"
                    class=""
                  ></path>
                </g>
              </svg>
            </button>
          </div>
        </div>
        <div class="tableview-top-search mobile">
          <label>
            <svg
              class="tableview-top-search-icon"
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.9996 16.94L13.3031 12.2435C14.5231 10.7515 15.1229 8.84761 14.9785 6.92571C14.8341 5.00381 13.9565 3.21094 12.5273 1.91793C11.0981 0.624921 9.22654 -0.0692924 7.29982 -0.0211186C5.37311 0.0270553 3.53862 0.813931 2.1758 2.17675C0.812985 3.53957 0.0261092 5.37406 -0.0220646 7.30077C-0.0702385 9.22748 0.623975 11.099 1.91698 12.5282C3.20999 13.9574 5.00287 14.835 6.92476 14.9794C8.84666 15.1238 10.7505 14.524 12.2426 13.304L16.9391 18.0005L17.9996 16.94ZM7.49959 13.5005C6.3129 13.5005 5.15287 13.1486 4.16617 12.4894C3.17948 11.8301 2.41044 10.893 1.95632 9.79664C1.50219 8.70028 1.38337 7.49388 1.61488 6.33C1.84639 5.16611 2.41784 4.09701 3.25695 3.2579C4.09607 2.41878 5.16516 1.84734 6.32905 1.61583C7.49294 1.38432 8.69934 1.50314 9.79569 1.95726C10.8921 2.41139 11.8291 3.18042 12.4884 4.16712C13.1477 5.15381 13.4996 6.31385 13.4996 7.50054C13.4978 9.09129 12.8651 10.6164 11.7403 11.7412C10.6154 12.866 9.09034 13.4988 7.49959 13.5005Z"
                fill="#4D5460"
              />
            </svg>
            <input
              v-model="searchValue"
              type="text"
              placeholder="Найти объект..."
            />
            <button
              @click="this.searchValue = ''"
              v-if="searchValue !== ''"
              class="tableview-top-search-close"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18.707 6.70685L17.293 5.29285L12 10.5858L6.70697 5.29285L5.29297 6.70685L10.586 11.9998L5.29297 17.2928L6.70697 18.7068L12 13.4138L17.293 18.7068L18.707 17.2928L13.414 11.9998L18.707 6.70685Z"
                />
              </svg>
            </button>
          </label>
        </div>
        <div v-if="!startLoading" class="tableview-main">
          <div
            class="tableview-main-left"
            :class="{ 'not-selected': itemsSelected.length === 0 }"
          >
            <!-- v-model:items-selected="itemsSelected" -->
            <EasyDataTable
              :class="{
                'admin-table': $store.state.user.roles.includes('ROLE_ADMIN'),
              }"
              buttons-pagination
              :headers="tableHeaders"
              :items="tableItems"
              :search-value="searchValue"
              rows-of-page-separator-message="из"
              theme-color="#005291"
              class="objects-table"
              table-class-name="customize-table"
              @click-row="selectObject"
              :filter-options="filterOptions"
            >
              <template #item-status="item">
                <div class="status-point-container">
                  <div
                    class="status-point"
                    :class="{ inactive: item.status === 'ia' }"
                  ></div>
                </div>
              </template>

              <template #item-lastUpdateTime="item">
                <div class="status-point-container">
                  <div
                    class="status-point"
                    :style="GetStatusColor(item.lastUpdateTime)"
                  ></div>
                </div>
              </template>

              <template #item-model="item">
                <div class="model-container">
                  {{ item.model }}
                </div>
                <div
                  class="selected-field"
                  :class="{ selected: item.id === selectedObject.id }"
                ></div>
              </template>

              <template #empty-message> Данные не найдены </template>

              <!-- status filter-->
              <template
                v-if="$store.state.user.roles.includes('ROLE_ADMIN')"
                #header-status="header"
              >
                <div
                  class="filter-column"
                  :class="{ selected: statusCriteria !== 'Все' }"
                >
                  <button
                    class="filter-icon"
                    @click.stop="
                      showStatusFilter = !showStatusFilter;
                      showCarrierFilter = false;
                      showConnectionStatusFilter = false;
                    "
                  >
                    <FilterIcon v-if="statusCriteria === 'Все'"/>
                    <FilterSelectedIcon v-if="statusCriteria !== 'Все'"/>
                  </button>
                  {{ header.text }}
                  <div @click.stop class="filter-menu" v-if="showStatusFilter">
                    <Multiselect
                      v-model="statusCriteria"
                      :canDeselect="false"
                      :options="[
                        { value: 'Все', label: 'Все' },
                        { value: 'a', label: 'Активный' },
                        { value: 'ia', label: 'Неактивный' },
                      ]"
                    />
                  </div>
                </div>
              </template>

              <!-- connection status filter-->
              <template #header-lastUpdateTime="header">
                <div
                  class="filter-column"
                  :class="{ selected: connectionStatusCriteria !== 'Все' }"
                >
                  <button
                    class="filter-icon"
                    @click.stop="
                      showConnectionStatusFilter = !showConnectionStatusFilter;
                      showCarrierFilter = false;
                      showStatusFilter = false;
                    "
                  >
                    <FilterIcon v-if="connectionStatusCriteria === 'Все'"/>
                    <FilterSelectedIcon v-if="connectionStatusCriteria !== 'Все'"/>
                  </button>
                  {{ header.text }}
                  <div
                    @click.stop
                    class="filter-menu"
                    v-if="showConnectionStatusFilter"
                  >
                    <Multiselect
                      v-model="connectionStatusCriteria"
                      :canDeselect="false"
                      :options="[
                        'Все',
                        'Хороший\u00A0сигнал',
                        'Средний\u00A0сигнал',
                        'Слабый\u00A0сигнал',
                        'Нет\u00A0данных',
                      ]"
                    />
                  </div>
                </div>
              </template>

              <!-- carrier filter-->
              <template #header-carrierName="header">
                <div
                  class="filter-column"
                  :class="{ selected: carrierCriteria !== 'Все' }"
                >
                  <button
                    class="filter-icon"
                    @click.stop="
                      showCarrierFilter = !showCarrierFilter;
                      showStatusFilter = false;
                      showConnectionStatusFilter = false;
                    "
                  >
                    <FilterIcon v-if="carrierCriteria === 'Все'"/>
                    <FilterSelectedIcon v-if="carrierCriteria !== 'Все'"/>
                  </button>
                  {{ header.text }}
                  <div @click.stop class="filter-menu" v-if="showCarrierFilter">
                    <Multiselect
                      v-model="carrierCriteria"
                      :searchable="true"
                      :canDeselect="false"
                      :options="[
                        'Все',
                        ...multiselectItems.map((item) => item.label),
                      ]"
                    />
                  </div>
                </div>
              </template>
            </EasyDataTable>
            <div
              class="tableview-main-selected"
              v-if="itemsSelected.length > 0"
            >
              <div class="tableview-main-selected-left">
                Выбрано: {{ itemsSelected.length }}
              </div>
              <div class="tableview-main-selected-actions">
                <div class="tableview-main-selected-actions-text">
                  Действия с выбранными:
                </div>
<!--                <button class="download-btn">-->
<!--                  <svg-->
<!--                    width="21"-->
<!--                    height="21"-->
<!--                    viewBox="0 0 21 21"-->
<!--                    fill="none"-->
<!--                    xmlns="http://www.w3.org/2000/svg"-->
<!--                  >-->
<!--                    <g clip-path="url(#clip0_1_1594)">-->
<!--                      <path-->
<!--                        d="M16.1218 17.4451C16.1948 17.5268 16.2509 17.6221 16.287 17.7255C16.3231 17.8289 16.3385 17.9385 16.3322 18.0478C16.326 18.1572 16.2982 18.2642 16.2505 18.3629C16.2028 18.4615 16.1362 18.5497 16.0543 18.6226L14.7327 19.8009C14.5062 20.0251 14.2377 20.2023 13.9425 20.3223C13.6473 20.4422 13.3313 20.5027 13.0127 20.5001C12.6822 20.5007 12.3549 20.4361 12.0494 20.31C11.744 20.1839 11.4664 19.9987 11.2327 19.7651L9.94601 18.6201C9.86426 18.5473 9.79764 18.4591 9.74997 18.3606C9.70229 18.2621 9.67449 18.1552 9.66814 18.0459C9.65533 17.8252 9.7307 17.6085 9.87767 17.4434C10.0246 17.2783 10.2312 17.1784 10.4519 17.1655C10.5611 17.1592 10.6706 17.1744 10.7739 17.2104C10.8773 17.2463 10.9726 17.3023 11.0543 17.3751L12.1668 18.3701V12.1667C12.1668 11.9457 12.2546 11.7338 12.4109 11.5775C12.5672 11.4212 12.7792 11.3334 13.0002 11.3334C13.2212 11.3334 13.4331 11.4212 13.5894 11.5775C13.7457 11.7338 13.8335 11.9457 13.8335 12.1667V18.3709L14.946 17.3776C15.1109 17.2307 15.3274 17.1554 15.5479 17.168C15.7684 17.1807 15.9748 17.2803 16.1218 17.4451V17.4451ZM15.7968 6.63424C15.6538 6.5898 15.5239 6.5106 15.4189 6.40372C15.3139 6.29683 15.237 6.16559 15.1952 6.02174C14.7539 4.60514 13.8527 3.37623 12.6343 2.52958C11.4158 1.68293 9.94978 1.26694 8.46825 1.34748C6.98672 1.42802 5.57439 2.00048 4.4549 2.97422C3.33542 3.94796 2.57275 5.26733 2.28767 6.7234C1.99516 8.19591 2.23122 9.72441 2.95434 11.0401C2.11138 11.4753 1.42593 12.1636 0.99427 13.0084C0.562611 13.8532 0.406433 14.812 0.547673 15.7501C0.764882 16.8399 1.34835 17.8227 2.20119 18.5351C3.05402 19.2476 4.12491 19.6469 5.23601 19.6667H7.16684C7.38785 19.6667 7.59981 19.5789 7.75609 19.4227C7.91237 19.2664 8.00017 19.0544 8.00017 18.8334C8.00017 18.6124 7.91237 18.4004 7.75609 18.2441C7.59981 18.0879 7.38785 18.0001 7.16684 18.0001H5.23601C4.5243 17.9864 3.83784 17.734 3.28683 17.2833C2.73582 16.8327 2.35224 16.2099 2.19767 15.5151C2.10718 14.918 2.20592 14.3077 2.48003 13.7696C2.75413 13.2316 3.18985 12.7929 3.72601 12.5151C4.10817 12.3039 4.39178 11.9507 4.51546 11.5319C4.63913 11.1131 4.59293 10.6625 4.38684 10.2776C4.06326 9.66045 3.87225 8.9825 3.82605 8.28722C3.77986 7.59195 3.87949 6.89469 4.11858 6.24018C4.35766 5.58567 4.73091 4.98836 5.21438 4.48656C5.69785 3.98476 6.28086 3.58956 6.92603 3.3263C7.57119 3.06305 8.26426 2.93755 8.96078 2.95785C9.65729 2.97816 10.3419 3.14383 10.9706 3.44423C11.5993 3.74463 12.1583 4.17314 12.6117 4.70225C13.0652 5.23136 13.403 5.84941 13.6035 6.51674C13.7268 6.91899 13.9466 7.28504 14.2436 7.58305C14.5405 7.88107 14.9058 8.10203 15.3077 8.22674C16.3963 8.55798 17.3384 9.25231 17.9771 10.194C18.6158 11.1357 18.9125 12.2678 18.8177 13.4017C18.7549 14.2834 18.4328 15.1269 17.8918 15.8259C17.7571 16.0012 17.6976 16.2228 17.7262 16.442C17.7549 16.6611 17.8695 16.8599 18.0448 16.9947C18.22 17.1294 18.4416 17.1889 18.6608 17.1603C18.88 17.1316 19.0788 17.017 19.2135 16.8417C19.9477 15.8845 20.3878 14.7345 20.4802 13.5317C20.606 12.0198 20.2098 10.5104 19.3576 9.25526C18.5053 8.0001 17.2486 7.07501 15.7968 6.63424V6.63424Z"-->
<!--                        fill="#374957"-->
<!--                      />-->
<!--                    </g>-->
<!--                    <defs>-->
<!--                      <clipPath id="clip0_1_1594">-->
<!--                        <rect-->
<!--                          width="20"-->
<!--                          height="20"-->
<!--                          fill="white"-->
<!--                          transform="translate(0.5 0.5)"-->
<!--                        />-->
<!--                      </clipPath>-->
<!--                    </defs>-->
<!--                  </svg>-->
<!--                  <span class="pc">Скачать в Excel</span>-->
<!--                  <span class="mobile">Excel</span>-->
<!--                </button>-->
<!--                <button class="download-btn">-->
<!--                  <svg-->
<!--                    width="21"-->
<!--                    height="21"-->
<!--                    viewBox="0 0 21 21"-->
<!--                    fill="none"-->
<!--                    xmlns="http://www.w3.org/2000/svg"-->
<!--                  >-->
<!--                    <g clip-path="url(#clip0_1_1594)">-->
<!--                      <path-->
<!--                        d="M16.1218 17.4451C16.1948 17.5268 16.2509 17.6221 16.287 17.7255C16.3231 17.8289 16.3385 17.9385 16.3322 18.0478C16.326 18.1572 16.2982 18.2642 16.2505 18.3629C16.2028 18.4615 16.1362 18.5497 16.0543 18.6226L14.7327 19.8009C14.5062 20.0251 14.2377 20.2023 13.9425 20.3223C13.6473 20.4422 13.3313 20.5027 13.0127 20.5001C12.6822 20.5007 12.3549 20.4361 12.0494 20.31C11.744 20.1839 11.4664 19.9987 11.2327 19.7651L9.94601 18.6201C9.86426 18.5473 9.79764 18.4591 9.74997 18.3606C9.70229 18.2621 9.67449 18.1552 9.66814 18.0459C9.65533 17.8252 9.7307 17.6085 9.87767 17.4434C10.0246 17.2783 10.2312 17.1784 10.4519 17.1655C10.5611 17.1592 10.6706 17.1744 10.7739 17.2104C10.8773 17.2463 10.9726 17.3023 11.0543 17.3751L12.1668 18.3701V12.1667C12.1668 11.9457 12.2546 11.7338 12.4109 11.5775C12.5672 11.4212 12.7792 11.3334 13.0002 11.3334C13.2212 11.3334 13.4331 11.4212 13.5894 11.5775C13.7457 11.7338 13.8335 11.9457 13.8335 12.1667V18.3709L14.946 17.3776C15.1109 17.2307 15.3274 17.1554 15.5479 17.168C15.7684 17.1807 15.9748 17.2803 16.1218 17.4451V17.4451ZM15.7968 6.63424C15.6538 6.5898 15.5239 6.5106 15.4189 6.40372C15.3139 6.29683 15.237 6.16559 15.1952 6.02174C14.7539 4.60514 13.8527 3.37623 12.6343 2.52958C11.4158 1.68293 9.94978 1.26694 8.46825 1.34748C6.98672 1.42802 5.57439 2.00048 4.4549 2.97422C3.33542 3.94796 2.57275 5.26733 2.28767 6.7234C1.99516 8.19591 2.23122 9.72441 2.95434 11.0401C2.11138 11.4753 1.42593 12.1636 0.99427 13.0084C0.562611 13.8532 0.406433 14.812 0.547673 15.7501C0.764882 16.8399 1.34835 17.8227 2.20119 18.5351C3.05402 19.2476 4.12491 19.6469 5.23601 19.6667H7.16684C7.38785 19.6667 7.59981 19.5789 7.75609 19.4227C7.91237 19.2664 8.00017 19.0544 8.00017 18.8334C8.00017 18.6124 7.91237 18.4004 7.75609 18.2441C7.59981 18.0879 7.38785 18.0001 7.16684 18.0001H5.23601C4.5243 17.9864 3.83784 17.734 3.28683 17.2833C2.73582 16.8327 2.35224 16.2099 2.19767 15.5151C2.10718 14.918 2.20592 14.3077 2.48003 13.7696C2.75413 13.2316 3.18985 12.7929 3.72601 12.5151C4.10817 12.3039 4.39178 11.9507 4.51546 11.5319C4.63913 11.1131 4.59293 10.6625 4.38684 10.2776C4.06326 9.66045 3.87225 8.9825 3.82605 8.28722C3.77986 7.59195 3.87949 6.89469 4.11858 6.24018C4.35766 5.58567 4.73091 4.98836 5.21438 4.48656C5.69785 3.98476 6.28086 3.58956 6.92603 3.3263C7.57119 3.06305 8.26426 2.93755 8.96078 2.95785C9.65729 2.97816 10.3419 3.14383 10.9706 3.44423C11.5993 3.74463 12.1583 4.17314 12.6117 4.70225C13.0652 5.23136 13.403 5.84941 13.6035 6.51674C13.7268 6.91899 13.9466 7.28504 14.2436 7.58305C14.5405 7.88107 14.9058 8.10203 15.3077 8.22674C16.3963 8.55798 17.3384 9.25231 17.9771 10.194C18.6158 11.1357 18.9125 12.2678 18.8177 13.4017C18.7549 14.2834 18.4328 15.1269 17.8918 15.8259C17.7571 16.0012 17.6976 16.2228 17.7262 16.442C17.7549 16.6611 17.8695 16.8599 18.0448 16.9947C18.22 17.1294 18.4416 17.1889 18.6608 17.1603C18.88 17.1316 19.0788 17.017 19.2135 16.8417C19.9477 15.8845 20.3878 14.7345 20.4802 13.5317C20.606 12.0198 20.2098 10.5104 19.3576 9.25526C18.5053 8.0001 17.2486 7.07501 15.7968 6.63424V6.63424Z"-->
<!--                        fill="#374957"-->
<!--                      />-->
<!--                    </g>-->
<!--                    <defs>-->
<!--                      <clipPath id="clip0_1_1594">-->
<!--                        <rect-->
<!--                          width="20"-->
<!--                          height="20"-->
<!--                          fill="white"-->
<!--                          transform="translate(0.5 0.5)"-->
<!--                        />-->
<!--                      </clipPath>-->
<!--                    </defs>-->
<!--                  </svg>-->
<!--                  <span class="pc">Скачать в PDF</span>-->
<!--                  <span class="mobile">PDF</span>-->
<!--                </button>-->
                <button
                  v-if="$store.state.user.roles.includes('ROLE_DELETE_OBJECT')"
                  @click="deleteMultiple"
                  class="delete-selected-btn"
                >
                  <svg
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_1_1597)">
                      <path
                        d="M18.8337 3.83333H14.667V2.16667C14.667 1.72464 14.4914 1.30072 14.1788 0.988155C13.8663 0.675595 13.4424 0.5 13.0003 0.5H8.00033C7.5583 0.5 7.13437 0.675595 6.82181 0.988155C6.50925 1.30072 6.33366 1.72464 6.33366 2.16667V3.83333H2.16699V5.5H3.83366V18C3.83366 18.663 4.09705 19.2989 4.56589 19.7678C5.03473 20.2366 5.67062 20.5 6.33366 20.5H14.667C15.33 20.5 15.9659 20.2366 16.4348 19.7678C16.9036 19.2989 17.167 18.663 17.167 18V5.5H18.8337V3.83333ZM8.00033 2.16667H13.0003V3.83333H8.00033V2.16667ZM15.5003 18C15.5003 18.221 15.4125 18.433 15.2562 18.5893C15.1 18.7455 14.888 18.8333 14.667 18.8333H6.33366C6.11265 18.8333 5.90068 18.7455 5.7444 18.5893C5.58812 18.433 5.50033 18.221 5.50033 18V5.5H15.5003V18Z"
                        fill="#FF7C7C"
                      />
                      <path
                        d="M9.66666 8.83282H8V15.4995H9.66666V8.83282Z"
                        fill="#FF7C7C"
                      />
                      <path
                        d="M13.0007 8.83282H11.334V15.4995H13.0007V8.83282Z"
                        fill="#FF7C7C"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1_1597">
                        <rect
                          width="20"
                          height="20"
                          fill="white"
                          transform="translate(0.5 0.5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                  <span>Удалить</span>
                </button>
              </div>
            </div>
          </div>
          <div v-if="selectedObject !== -1" class="tableview-main-right">
            <div class="tableview-main-right-top">
              <div class="tableview-main-right-name">
                {{ selectedObject.gosNumber }}
              </div>
              <div
                v-if="$store.state.user.roles.includes('ROLE_ADMIN')"
                class="tableview-main-right-status"
                :class="{ inactive: selectedObject.status === 'ia' }"
              />
              <div
                v-if="!$store.state.user.roles.includes('ROLE_ADMIN')"
                class="tableview-main-right-status"
                :style="GetStatusColor(selectedObject.lastUpdateTime)"
              />
            </div>
            <div class="tableview-main-right-info">
              <div
                class="tableview-main-right-model"
                v-show="selectedObject.model"
              >
                {{ selectedObject.model }}
              </div>
              <div
                class="tableview-main-right-speed"
                :style="GetStatusColor(selectedObject.lastUpdateTime)"
              >
                {{
                  selectedObject.current_speed
                    ? selectedObject.current_speed
                    : "---"
                }}
                км/ч
              </div>
            </div>
            <div class="tableview-main-right-additional">
              <div class="tableview-main-right-additional-icon">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M22.767 8.392L15.535 1.464C14.6 0.529225 13.3327 0.00285293 12.0106 4.18348e-05C10.6884 -0.00276926 9.419 0.518209 8.48 1.449L1.233 8.392C0.844071 8.76591 0.534448 9.21434 0.322607 9.71052C0.110766 10.2067 0.00104801 10.7405 0 11.28L0 24H24V11.28C23.999 10.7405 23.8892 10.2067 23.6774 9.71052C23.4656 9.21434 23.1559 8.76591 22.767 8.392ZM9.879 2.878C10.4522 2.32794 11.2168 2.02212 12.0112 2.02511C12.8057 2.02809 13.5679 2.33964 14.137 2.894L20.885 9.358L14.121 16.122C13.5493 16.6669 12.7898 16.9709 12 16.9709C11.2102 16.9709 10.4507 16.6669 9.879 16.122L3.115 9.358L9.879 2.878ZM22 22H2V11.28C2 11.216 2.013 11.154 2.019 11.09L8.465 17.536C9.40264 18.4734 10.6742 18.9999 12 18.9999C13.3258 18.9999 14.5974 18.4734 15.535 17.536L21.981 11.09C21.987 11.154 22 11.216 22 11.28V22Z"
                    fill="#374957"
                  />
                </svg>
              </div>
              <div>
                <div class="tableview-main-right-additional-label">
                  Последнее сообщение:
                </div>
                <div class="tableview-main-right-additional-value">
                  {{ GetLastTime(selectedObject.lastUpdateTime) }}
                </div>
              </div>
            </div>
            <div class="tableview-main-right-additional">
              <div class="tableview-main-right-additional-icon">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 12.0001C12.7911 12.0001 13.5645 11.7655 14.2223 11.3259C14.8801 10.8864 15.3928 10.2617 15.6955 9.5308C15.9983 8.79989 16.0775 7.99562 15.9231 7.2197C15.7688 6.44378 15.3878 5.73104 14.8284 5.17163C14.269 4.61222 13.5563 4.23126 12.7804 4.07692C12.0044 3.92258 11.2002 4.00179 10.4693 4.30454C9.73836 4.60729 9.11365 5.11998 8.67412 5.77778C8.2346 6.43558 8 7.20894 8 8.00006C8 9.06093 8.42143 10.0783 9.17157 10.8285C9.92172 11.5786 10.9391 12.0001 12 12.0001ZM12 6.00006C12.3956 6.00006 12.7822 6.11736 13.1111 6.33712C13.44 6.55688 13.6964 6.86924 13.8478 7.23469C13.9991 7.60015 14.0387 8.00228 13.9616 8.39024C13.8844 8.7782 13.6939 9.13457 13.4142 9.41427C13.1345 9.69398 12.7781 9.88446 12.3902 9.96163C12.0022 10.0388 11.6001 9.9992 11.2346 9.84782C10.8692 9.69645 10.5568 9.4401 10.3371 9.1112C10.1173 8.7823 10 8.39562 10 8.00006C10 7.46963 10.2107 6.96092 10.5858 6.58585C10.9609 6.21077 11.4696 6.00006 12 6.00006ZM16 22.0301L24 23.9781V13.4831C23.9998 12.8389 23.7923 12.212 23.4081 11.6949C23.024 11.1779 22.4836 10.7982 21.867 10.6121L19.767 9.91206C19.9206 9.28832 19.9988 8.64842 20 8.00606C20 5.88433 19.1572 3.8495 17.6569 2.34921C16.1566 0.848914 14.1217 0.00605965 12 0.00605965C9.87827 0.00605965 7.84344 0.848914 6.34315 2.34921C4.84286 3.8495 4 5.88433 4 8.00606C4.00296 8.41199 4.03639 8.81713 4.1 9.21806C3.64587 9.03701 3.15429 8.97001 2.66827 9.02291C2.18225 9.0758 1.7166 9.24699 1.31205 9.52149C0.907496 9.796 0.576373 10.1655 0.347646 10.5975C0.118919 11.0296 -0.000443211 11.5112 1.23664e-06 12.0001V21.7521L7.983 24.0331L16 22.0301ZM7.757 3.76406C8.88425 2.65281 10.4049 2.03203 11.9878 2.03694C13.5707 2.04185 15.0875 2.67205 16.2079 3.79027C17.3282 4.90849 17.9612 6.42412 17.9691 8.00699C17.977 9.58986 17.3591 11.1117 16.25 12.2411L12 16.4001L7.757 12.2491C6.63187 11.1239 5.99978 9.59779 5.99978 8.00656C5.99978 6.41533 6.63187 4.88927 7.757 3.76406ZM2 12.0001C1.99874 11.8351 2.03891 11.6725 2.11684 11.5272C2.19476 11.3818 2.30795 11.2583 2.446 11.1681C2.59041 11.0733 2.75678 11.0172 2.92911 11.0053C3.10143 10.9934 3.27392 11.026 3.43 11.1001L4.864 11.6181C5.24766 12.3778 5.74958 13.0718 6.351 13.6741L12 19.2001L17.657 13.6671C18.2133 13.1116 18.6849 12.4775 19.057 11.7851L21.274 12.5261C21.4828 12.5858 21.6665 12.7119 21.7973 12.8852C21.9281 13.0586 21.9989 13.2699 21.999 13.4871V21.4361L16 19.9701L8.02 21.9701L2 20.2461V12.0001Z"
                    fill="#374957"
                  />
                </svg>
              </div>
              <div>
                <div class="tableview-main-right-additional-label">
                  Местонахождение:
                </div>
                <div class="tableview-main-right-additional-value">
                  {{ CurrentAddress }}
                </div>
              </div>
            </div>
            <div class="tableview-main-right-divider"></div>
            <div
              v-if="$store.state.user.roles.includes('ROLE_ADMIN')"
              class="singleselect-label-wrapper"
              :class="{
                'pointers-inactive':
                  !$store.state.user.roles.includes('ROLE_ADMIN'),
              }"
            >
              <div class="edit-multiselect-label">Статус</div>
              <Multiselect
                v-model="editableObject.status"
                noResultsText="Результаты не найдены"
                :canDeselect="false"
                :options="[
                  { value: 'a', label: 'Активный' },
                  { value: 'ia', label: 'Неактивный' },
                ]"
              />
              <!-- <label class="permanent-check">
                <input
                    type="checkbox"
                    class="form-check-input"
                    name="terms"
                    v-model="editableObject.permanent"/>
                <span>Постоянный</span>
              </label> -->
            </div>
            <div class="singleselect-label-wrapper">
              <div class="edit-multiselect-label">Перевозчик</div>
              <Multiselect
                v-model="editableObject.carrierId"
                :searchable="true"
                noResultsText="Результаты не найдены"
                :canDeselect="false"
                :disabled="true"
                :options="multiselectItems"
              />
            </div>
            <label
              class="edit-input"
              :class="{ 'error-input': editValidationErrors.modelError }"
            >
              <div class="edit-input-label">Марка/модель</div>
              <input
                v-model="editableObject.model"
                type="text"
                placeholder="Введите марку/модель"
              />
              <div class="edit-error" v-if="editValidationErrors.modelError">
                {{ editValidationErrors.modelError }}
              </div>
            </label>
            <label
              class="edit-input"
              :class="{ 'error-input': editValidationErrors.gosNumberError }"
            >
              <div class="edit-input-label">Гос. номер ТС</div>
              <input
                v-model="editableObject.gosNumber"
                type="text"
                placeholder="Введите гос. номер ТС"
              />
              <div
                class="edit-error"
                v-if="editValidationErrors.gosNumberError"
              >
                {{ editValidationErrors.gosNumberError }}
              </div>
            </label>
            <label
              class="edit-input"
              :class="{ 'error-input': editValidationErrors.imeiError }"
            >
              <div class="edit-input-label">IMEI</div>
              <input
                v-model="editableObject.imei"
                type="text"
                placeholder="Введите IMEI"
              />
              <div class="edit-error" v-if="editValidationErrors.imeiError">
                {{ editValidationErrors.imeiError }}
              </div>
            </label>
            <!-- <div class="singleselect-label-wrapper">
              <div class="edit-multiselect-label">Протокол</div>
              <Multiselect
                  v-model="editableObject.protocolId"
                  :searchable="true"
                  @select="selectProtocol(editableObject.protocolId, 'edit')"
                  label="name"
                  noResultsText="Результаты не найдены"
                  :canDeselect="false"
                  :options="protocolsFull"
              />
            </div> -->
            <!-- <label class="edit-input d-flex align-items-center">
              <div class="edit-input-label">Адрес сервера</div>
              <input v-if="!editableObject.ipEnabled" v-model="editableObject.domain" readonly type="text"
                     style="cursor: default">
              <input v-if="editableObject.ipEnabled" v-model="editableObject.ip" readonly type="text"
                     style="cursor: default">
              <button
                  @click="changeIpStatus(editableObject)"
                  class="ip-button"
                  :class="{ 'active': editableObject.ipEnabled }"
              >
                IP
              </button>
            </label> -->
            <!-- <label class="edit-input">
              <div class="edit-input-label">Порт</div>
              <input v-model="editableObject.port" readonly type="text" style="cursor: default">
            </label> -->
            <button @click="updateObject" class="button-update">
              Сохранить изменения
            </button>
          </div>
        </div>
        <LoadingSpinner v-else />
      </div>
    </div>

    <!--    edit object modal-->
    <ModalView
      class="edit-modal"
      v-model:show="editDialogVisible"
      v-model:selectedObj="selectedObject"
      :title="'Объект: ' + selectedObject.gosNumber"
    >
      <div class="tableview-main-right-info">
        <div class="tableview-main-right-model" v-show="selectedObject.model">
          {{ selectedObject.model }}
        </div>
        <div
          class="tableview-main-right-speed"
          :style="GetStatusColor(selectedObject.lastUpdateTime)"
        >
          {{
            selectedObject.current_speed ? selectedObject.current_speed : "---"
          }}
          км/ч
        </div>
        <div
          v-if="$store.state.user.roles.includes('ROLE_ADMIN')"
          class="tableview-main-right-status"
          :class="{ inactive: selectedObject.status === 'ia' }"
        />
        <div
          v-if="!$store.state.user.roles.includes('ROLE_ADMIN')"
          class="tableview-main-right-status"
          :style="GetStatusColor(selectedObject.lastUpdateTime)"
        />
      </div>
      <div class="tableview-main-right-additional">
        <div class="tableview-main-right-additional-icon">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M22.767 8.392L15.535 1.464C14.6 0.529225 13.3327 0.00285293 12.0106 4.18348e-05C10.6884 -0.00276926 9.419 0.518209 8.48 1.449L1.233 8.392C0.844071 8.76591 0.534448 9.21434 0.322607 9.71052C0.110766 10.2067 0.00104801 10.7405 0 11.28L0 24H24V11.28C23.999 10.7405 23.8892 10.2067 23.6774 9.71052C23.4656 9.21434 23.1559 8.76591 22.767 8.392ZM9.879 2.878C10.4522 2.32794 11.2168 2.02212 12.0112 2.02511C12.8057 2.02809 13.5679 2.33964 14.137 2.894L20.885 9.358L14.121 16.122C13.5493 16.6669 12.7898 16.9709 12 16.9709C11.2102 16.9709 10.4507 16.6669 9.879 16.122L3.115 9.358L9.879 2.878ZM22 22H2V11.28C2 11.216 2.013 11.154 2.019 11.09L8.465 17.536C9.40264 18.4734 10.6742 18.9999 12 18.9999C13.3258 18.9999 14.5974 18.4734 15.535 17.536L21.981 11.09C21.987 11.154 22 11.216 22 11.28V22Z"
              fill="#374957"
            />
          </svg>
        </div>
        <div>
          <div class="tableview-main-right-additional-label">
            Последнее сообщение:
          </div>
          <div class="tableview-main-right-additional-value">
            {{ GetLastTime(selectedObject.lastUpdateTime) }}
          </div>
        </div>
      </div>
      <div class="tableview-main-right-additional">
        <div class="tableview-main-right-additional-icon">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 12.0001C12.7911 12.0001 13.5645 11.7655 14.2223 11.3259C14.8801 10.8864 15.3928 10.2617 15.6955 9.5308C15.9983 8.79989 16.0775 7.99562 15.9231 7.2197C15.7688 6.44378 15.3878 5.73104 14.8284 5.17163C14.269 4.61222 13.5563 4.23126 12.7804 4.07692C12.0044 3.92258 11.2002 4.00179 10.4693 4.30454C9.73836 4.60729 9.11365 5.11998 8.67412 5.77778C8.2346 6.43558 8 7.20894 8 8.00006C8 9.06093 8.42143 10.0783 9.17157 10.8285C9.92172 11.5786 10.9391 12.0001 12 12.0001ZM12 6.00006C12.3956 6.00006 12.7822 6.11736 13.1111 6.33712C13.44 6.55688 13.6964 6.86924 13.8478 7.23469C13.9991 7.60015 14.0387 8.00228 13.9616 8.39024C13.8844 8.7782 13.6939 9.13457 13.4142 9.41427C13.1345 9.69398 12.7781 9.88446 12.3902 9.96163C12.0022 10.0388 11.6001 9.9992 11.2346 9.84782C10.8692 9.69645 10.5568 9.4401 10.3371 9.1112C10.1173 8.7823 10 8.39562 10 8.00006C10 7.46963 10.2107 6.96092 10.5858 6.58585C10.9609 6.21077 11.4696 6.00006 12 6.00006ZM16 22.0301L24 23.9781V13.4831C23.9998 12.8389 23.7923 12.212 23.4081 11.6949C23.024 11.1779 22.4836 10.7982 21.867 10.6121L19.767 9.91206C19.9206 9.28832 19.9988 8.64842 20 8.00606C20 5.88433 19.1572 3.8495 17.6569 2.34921C16.1566 0.848914 14.1217 0.00605965 12 0.00605965C9.87827 0.00605965 7.84344 0.848914 6.34315 2.34921C4.84286 3.8495 4 5.88433 4 8.00606C4.00296 8.41199 4.03639 8.81713 4.1 9.21806C3.64587 9.03701 3.15429 8.97001 2.66827 9.02291C2.18225 9.0758 1.7166 9.24699 1.31205 9.52149C0.907496 9.796 0.576373 10.1655 0.347646 10.5975C0.118919 11.0296 -0.000443211 11.5112 1.23664e-06 12.0001V21.7521L7.983 24.0331L16 22.0301ZM7.757 3.76406C8.88425 2.65281 10.4049 2.03203 11.9878 2.03694C13.5707 2.04185 15.0875 2.67205 16.2079 3.79027C17.3282 4.90849 17.9612 6.42412 17.9691 8.00699C17.977 9.58986 17.3591 11.1117 16.25 12.2411L12 16.4001L7.757 12.2491C6.63187 11.1239 5.99978 9.59779 5.99978 8.00656C5.99978 6.41533 6.63187 4.88927 7.757 3.76406ZM2 12.0001C1.99874 11.8351 2.03891 11.6725 2.11684 11.5272C2.19476 11.3818 2.30795 11.2583 2.446 11.1681C2.59041 11.0733 2.75678 11.0172 2.92911 11.0053C3.10143 10.9934 3.27392 11.026 3.43 11.1001L4.864 11.6181C5.24766 12.3778 5.74958 13.0718 6.351 13.6741L12 19.2001L17.657 13.6671C18.2133 13.1116 18.6849 12.4775 19.057 11.7851L21.274 12.5261C21.4828 12.5858 21.6665 12.7119 21.7973 12.8852C21.9281 13.0586 21.9989 13.2699 21.999 13.4871V21.4361L16 19.9701L8.02 21.9701L2 20.2461V12.0001Z"
              fill="#374957"
            />
          </svg>
        </div>
        <div>
          <div class="tableview-main-right-additional-label">
            Местонахождение:
          </div>
          <div class="tableview-main-right-additional-value">
            {{ CurrentAddress }}
          </div>
        </div>
      </div>
      <div class="tableview-main-right-divider"></div>
      <div
        v-if="$store.state.user.roles.includes('ROLE_ADMIN')"
        class="singleselect-label-wrapper"
        :class="{
          'pointers-inactive': !$store.state.user.roles.includes('ROLE_ADMIN'),
        }"
      >
        <div class="edit-multiselect-label">Статус</div>
        <Multiselect
          v-model="editableObject.status"
          noResultsText="Результаты не найдены"
          :canDeselect="false"
          :options="[
            { value: 'a', label: 'Активный' },
            { value: 'ia', label: 'Неактивный' },
          ]"
        />
        <!-- <label class="permanent-check">
          <input
              type="checkbox"
              class="form-check-input"
              name="terms"
              v-model="editableObject.permanent"/>
          <span>Постоянный</span>
        </label> -->
      </div>
      <div class="singleselect-label-wrapper">
        <div class="edit-multiselect-label">Перевозчик</div>
        <Multiselect
          v-model="editableObject.carrierId"
          :searchable="true"
          noResultsText="Результаты не найдены"
          :canDeselect="false"
          :disabled="true"
          :options="multiselectItems"
        />
      </div>
      <label
        class="edit-input"
        :class="{ 'error-input': editValidationErrors.modelError }"
      >
        <div class="edit-input-label">Марка/модель</div>
        <input
          v-model="editableObject.model"
          type="text"
          placeholder="Введите марку/модель"
        />
        <div class="edit-error" v-if="editValidationErrors.modelError">
          {{ editValidationErrors.modelError }}
        </div>
      </label>
      <label
        class="edit-input"
        :class="{ 'error-input': editValidationErrors.gosNumberError }"
      >
        <div class="edit-input-label">Гос. номер ТС</div>
        <input
          v-model="editableObject.gosNumber"
          type="text"
          placeholder="Введите гос. номер ТС"
        />
        <div class="edit-error" v-if="editValidationErrors.gosNumberError">
          {{ editValidationErrors.gosNumberError }}
        </div>
      </label>
      <label
        class="edit-input"
        :class="{ 'error-input': editValidationErrors.imeiError }"
      >
        <div class="edit-input-label">IMEI</div>
        <input
          v-model="editableObject.imei"
          type="text"
          placeholder="Введите IMEI"
        />
        <div class="edit-error" v-if="editValidationErrors.imeiError">
          {{ editValidationErrors.imeiError }}
        </div>
      </label>
      <div class="singleselect-label-wrapper">
        <div class="edit-multiselect-label">Протокол</div>
        <Multiselect
          v-model="editableObject.protocolId"
          :searchable="true"
          @select="selectProtocol(editableObject.protocolId, 'edit')"
          label="name"
          noResultsText="Результаты не найдены"
          :canDeselect="false"
          :options="protocolsFull"
        />
      </div>
      <!-- <label class="edit-input d-flex align-items-center">
        <div class="edit-input-label">Адрес сервера</div>
        <input v-if="!editableObject.ipEnabled" v-model="editableObject.domain" readonly type="text"
               style="cursor: default">
        <input v-if="editableObject.ipEnabled" v-model="editableObject.ip" readonly type="text"
               style="cursor: default">
        <button
            @click="changeIpStatus(editableObject)"
            class="ip-button"
            :class="{ 'active': editableObject.ipEnabled }"
        >
          IP
        </button>
      </label> -->
      <!-- <label class="edit-input">
        <div class="edit-input-label">Порт</div>
        <input v-model="editableObject.port" readonly type="text" style="cursor: default">
      </label> -->
      <template v-slot:footer>
        <!-- content for the footer slot -->
        <button @click="updateObject" type="button" class="button-add">
          Сохранить изменения
        </button>
      </template>
    </ModalView>
  </div>
</template>

<script>
import NavigationView from "@/components/NavigationView";
import store from "@/store";
import http from "@/http";
import LoadingSpinner from "@/components/LoadingSpinner";
import ModalView from "@/components/ModalView";
import Multiselect from "@vueform/multiselect";
import { toast } from "vue3-toastify";
import Swal from "@/sweetalert2";
import "vue3-toastify/dist/index.css";
import FilterIcon from "@/components/icons/filter-icon.vue";
import FilterSelectedIcon from "@/components/icons/filter-selected-icon.vue";
import {
  formatTimeDifference,
  getAddress,
  getColorBasedOnTimeDifference,
  getTextBasedOnTimeDifference,
} from "@/MainFunctions";

export default {
  name: "ObjectsView",
  beforeMount() {
    if (store.state.user.roles.length === 0) {
      this.$router.push("/login");
    }
  },
  mounted() {
    if (store.state.user.roles.length > 0) {
      if (store.state.user.roles.includes("ROLE_ADMIN")) {
        this.tableHeaders.unshift({
          text: "Статус",
          value: "status",
          sortable: true,
          width: 100,
        });
      }
      this.fetchObjects();
    }
    document.addEventListener('click', this.onGlobalClick, { capture: true })
  },
  unmounted() {
    document.removeEventListener('click', this.onGlobalClick, { capture: true })
  },
  data() {
    return {
      startLoading: false,
      loading: false,
      CurrentAddress: null,
      searchValue: "",
      tableHeaders: [
        {
          text: "Статус соединения",
          value: "lastUpdateTime",
          sortable: true,
          width: 100,
        },
        { text: "Марка/модель", value: "model", sortable: true },
        { text: "Гос. номер ТС", value: "gosNumber", sortable: true },
        { text: "IMEI", value: "imei", sortable: true },
        { text: "Перевозчик", value: "carrierName", sortable: true },
      ],
      tableItems: [],
      multiselectItems: [],
      itemsSelected: [],
      selectedObject: -1,
      editableObject: -1,
      editValidationErrors: {},
      editDialogVisible: false,
      statusCriteria: "Все",
      showStatusFilter: false,
      connectionStatusCriteria: "Все",
      showConnectionStatusFilter: false,
      carrierCriteria: "Все",
      showCarrierFilter: false,
      protocolsFull: [],
    };
  },
  computed: {
    filterOptions() {
      const filterOptionsArray = [];
      if (this.statusCriteria !== "Все") {
        filterOptionsArray.push({
          field: "status",
          comparison: "=",
          criteria: this.statusCriteria,
        });
      }
      if (this.carrierCriteria !== "Все") {
        filterOptionsArray.push({
          field: "carrierName",
          comparison: "=",
          criteria: this.carrierCriteria,
        });
      }
      if (this.connectionStatusCriteria !== "Все") {
        filterOptionsArray.push({
          field: "lastUpdateTime",
          comparison: (value, criteria) => {
            return this.GetStatusText(value) === criteria;
          },
          criteria: this.connectionStatusCriteria,
        });
      }
      return filterOptionsArray;
    },
  },
  components: {
    NavigationView,
    LoadingSpinner,
    Multiselect,
    ModalView,
    FilterIcon,
    FilterSelectedIcon,
  },
  methods: {
    closeAllFilters() {
      this.showStatusFilter = false
      this.showConnectionStatusFilter = false
      this.showCarrierFilter = false
    },
    onGlobalClick(e) {
      if (e.target.closest('.filter-menu') || e.target.closest('.filter-icon')) return
      this.closeAllFilters();
    },
    GetLastTime(ltm) {
      return formatTimeDifference(ltm);
    },
    GetStatusColor(ltm) {
      return getColorBasedOnTimeDifference(ltm);
    },
    GetStatusText(ltm) {
      return getTextBasedOnTimeDifference(ltm);
    },
    async GetAddressByCoords(CoordsLat, CoordsLon) {
      this.CurrentAddress = "...";
      const address = await getAddress(CoordsLat, CoordsLon);
      this.CurrentAddress = address; // сохраняем полученный адрес в переменную состояния
    },
    async fetchObjects() {
      try {
        this.startLoading = true;
        const responses = await Promise.all([
          http.get("/api/car/get"),
          http.get("/api/carrier/get/short"),
          http.get("/api/protocol/list"),
        ]);
        if (responses[0].data !== null && responses[0].status === 200) {
          this.tableItems = responses[0].data;
        }
        if (responses[1].data !== null && responses[1].status === 200) {
          this.multiselectItems = responses[1].data.carriers;
          this.tableItems = this.tableItems.map((item) => {
            item.carrierName = this.multiselectItems.find(
              (elem) => elem.value === item.carrierId
            ).label;
            if (item.protocol && item.protocol.id) {
              item.protocolId = item.protocol.id;
            }
            return item;
          });
        }
        if (responses[2].data !== null && responses[2].status === 200) {
          this.protocolsFull = responses[2].data.map((item) => {
            item.value = item.id;
            return item;
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.startLoading = false;
      }
    },
    clearFilters() {
      this.searchValue = "";
      this.itemsSelected = [];
      this.selectedObject = -1;
      this.editableObject = -1;
      this.statusCriteria = "Все";
      this.carrierCriteria = "Все";
      this.connectionStatusCriteria = "Все";
      this.showStatusFilter = false;
      this.showCarrierFilter = false;
      this.showConnectionStatusFilter = false;
    },
    selectObject(item) {
      this.editValidationErrors = {};
      if (this.selectedObject.id === item.id) {
        this.selectedObject = -1;
        this.editableObject = -1;
        this.editDialogVisible = false;
      } else {
        this.selectedObject = item;
        this.editableObject = JSON.parse(JSON.stringify(item));
        this.editDialogVisible = true;

        // обновляем адрес при выборе объекта
        this.GetAddressByCoords(
          this.selectedObject.latitude,
          this.selectedObject.longitude
        );

        if (this.editableObject.protocolId) {
          var foundProtocol = this.protocolsFull.find(
            (item) => item.id === this.editableObject.protocolId
          );
          this.editableObject.ip = foundProtocol.ip;
          this.editableObject.port = foundProtocol.port;
          this.editableObject.domain = foundProtocol.domain;
        }
      }
    },
    async updateObject() {
      this.editValidationErrors = {};
      if (!this.editableObject.gosNumber) {
        this.editValidationErrors.gosNumberError = "Введите гос. номер ТС";
      }
      if (!this.editableObject.imei) {
        this.editValidationErrors.imeiError = "Введите IMEI";
      }
      if (!this.editableObject.protocolId) {
        this.editValidationErrors.protocolError = "Введите протокол";
      }
      if (Object.keys(this.editValidationErrors).length === 0) {
        try {
          this.loading = true;
          var data = {
            status: this.editableObject.status,
            // permanent: this.editableObject.permanent,
            carrierId: this.editableObject.carrierId,
            model: this.editableObject.model,
            gosNumber: this.editableObject.gosNumber,
            imei: this.editableObject.imei,
            // protocolId: this.editableObject.protocolId,
          };
          const response = await http.post(
            `/api/car/update/${this.editableObject.id}`,
            data
          );
          if (response.data !== null && response.status === 200) {
            var foundObject = this.tableItems.find(
              (item) => item.id === this.editableObject.id
            );
            foundObject.status = this.editableObject.status;
            // foundObject.permanent = this.editableObject.permanent;
            foundObject.carrierId = this.editableObject.carrierId;
            foundObject.carrierName = this.multiselectItems.find(
              (elem) => elem.value === this.editableObject.carrierId
            ).label;
            foundObject.model = this.editableObject.model;
            foundObject.gosNumber = this.editableObject.gosNumber;
            foundObject.imei = this.editableObject.imei;
            // foundObject.protocolId = this.editableObject.protocolId;

            this.selectedObject = -1;
            this.editableObject = -1;
            this.editDialogVisible = false;
            this.itemsSelected = [];
            toast.success("Изменения сохранены успешно!", {
              autoClose: 3000,
            });
          }
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false;
        }
      }
    },
    showCreateDialog() {
      this.createDialogVisible = true;
      this.createValidationErrors = {};
    },
    async deleteMultiple() {
      var result = await Swal.fire({
        title: "Вы уверены, что хотите удалить выбранные объекты?",
        text: "Они также будут удалены и в системе мониторинга!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#FF7C7C",
        cancelButtonColor: "#005291",
        cancelButtonText: "Отмена",
        confirmButtonText: "Удалить",
      });

      if (result.isConfirmed) {
        try {
          this.loading = true;
          var itemsForDelete = this.itemsSelected.map((item) => item.id);
          var data = {
            delete_elements: itemsForDelete,
          };
          const response = await http.post("/api/car/delete-multiple", data);
          if (response.data !== null && response.status === 200) {
            this.tableItems = this.tableItems.filter(
              (item) => !itemsForDelete.includes(item.id)
            );
            this.itemsSelected = [];
            toast.success("Выбранные объекты удалены успешно!", {
              autoClose: 3000,
            });
          }
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false;
        }
      }
    },
    selectProtocol(protocolId, method) {
      var foundProtocol = this.protocolsFull.find(
        (item) => item.id === protocolId
      );
      if (method === "edit") {
        this.editableObject.ip = foundProtocol.ip;
        this.editableObject.port = foundProtocol.port;
        this.editableObject.domain = foundProtocol.domain;
      }
    },
    changeIpStatus(object) {
      object.ipEnabled = !object.ipEnabled;
      if (object.ipEnabled) {
        Swal.fire({
          title:
            "Используйте адрес IP только если ваш трекер не работает с DNS адресом",
          icon: "info",
          confirmButtonColor: "#005291",
        });
      }
    },
  },
  /*watch: {*/
  /*  // Следим за изменениями координат и обновляем адрес*/
  /*  'selectedObject.latitude': function (newLat, oldLat) {*/
  //     if (newLat !== oldLat) {
  //       this.GetAddressByCoords(this.selectedObject.latitude, this.selectedObject.longitude);
  //     }
  //   },
  //   'selectedObject.longitude': function (newLon, oldLon) {
  //     if (newLon !== oldLon) {
  //       this.GetAddressByCoords(this.selectedObject.latitude, this.selectedObject.longitude);
  //     }
  //   }
  // }
};
</script>

<style scoped>
.spin {
  z-index: 1001;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  position: fixed;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.block-container {
  /*background-image: url("../assets/images/backfon.jpg");*/
  /*background-size: cover;*/
  /*background-position: center;*/
  height: calc(100vh - 60px);
  height: calc(100dvh - 60px);
  /*padding: 30px;*/
  overflow: hidden;
}
.multiselect.is-disabled {
  background: transparent !important;
  cursor: not-allowed !important;
}
.tableview-block {
  background: #ffffff;
  /*border-radius: 10px;*/
  height: 100%;
  position: relative;
  box-shadow: 0 5px 10px #aaacbd;
}

.tableview-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
}

.tableview-top-left {
  display: flex;
  align-items: center;
}

.tableview-top-count {
  font-size: 18px;
  font-family: OpenSansSemiBold, sans-serif;
  color: #005291;
  margin-right: 20px;
}

.tableview-top-search.mobile {
  display: none;
}

.tableview-top-search label {
  position: relative;
  display: flex;
}

.tableview-top-search label input {
  background-color: #ffffff;
  box-shadow: 0px 0px 10px #dde5ed;
  border: 0;
  outline: none;
  border-radius: 10px;
  width: 350px;
  height: 38px;
  padding: 10px 42px 10px 48px;
  font-size: 14px;
  font-family: OpenSansRegular, sans-serif;
  color: #4d5460;
}

.tableview-top-search label input::placeholder {
  color: #4d5460;
}

.tableview-top-search-icon {
  position: absolute;
  top: 11px;
  left: 13px;
  pointer-events: none;
}

.tableview-top-search-close {
  position: absolute;
  background: transparent;
  border: 0;
  outline: none;
  top: 8px;
  right: 9px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.tableview-top-search-close svg {
  fill: #4d5460;
}

.clear-filters {
  border-radius: 10px;
  color: #ff7c7c;
  font-family: OpenSansRegular, sans-serif;
  font-size: 13px;
  background: transparent;
  height: 38px;
  outline: none;
  padding: 0 12px;
  border: 1px solid #ff7c7c;
  cursor: pointer;
  transition: all 0.4s;
}

.clear-filters.mobile,
.button-add-transparent.mobile {
  display: none;
}

.button-add-transparent {
  border-radius: 10px;
  color: #4d5460;
  font-family: OpenSansRegular, sans-serif;
  font-size: 13px;
  background: transparent;
  height: 38px;
  outline: none;
  padding: 0 12px;
  margin-right: 10px;
  border: 1px solid #dde5ed;
  cursor: pointer;
  transition: all 0.4s;
}

.clear-filters:active,
.download-btn:active,
.delete-selected-btn:active,
.button-add-transparent:active {
  transform: scale(0.95);
}

.download-btn {
  border-radius: 10px;
  color: #4d5460;
  font-family: OpenSansRegular, sans-serif;
  font-size: 13px;
  background: transparent;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  padding: 0 12px;
  border: 1px solid #dde5ed;
  cursor: pointer;
  transition: all 0.4s;
  margin-right: 10px;
}

.download-btn .mobile {
  display: none;
}

.download-btn svg {
  margin-right: 8px;
}

.delete-selected-btn {
  border-radius: 10px;
  color: #ff7c7c;
  font-family: OpenSansRegular, sans-serif;
  font-size: 13px;
  background: transparent;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  padding: 0 12px;
  border: 1px solid #ff7c7c;
  cursor: pointer;
  transition: all 0.4s;
}

.delete-selected-btn svg {
  margin-right: 8px;
}

.tableview-main {
  display: flex;
  height: calc(100% - 68px);
}

.tableview-main-left {
  width: 100%;
  height: calc(100% - 122px);
}

.tableview-main-left.not-selected {
  height: calc(100% - 64px);
}

.tableview-main-selected {
  display: flex;
  align-items: center;
  margin-top: 43px;
  justify-content: space-between;
  padding: 20px 20px 20px 30px;
}

.tableview-main-selected-left {
  font-size: 14px;
  color: #4d5460;
}

.tableview-main-selected-actions {
  display: flex;
  align-items: center;
  justify-content: center;
}

.tableview-main-selected-actions-text {
  font-size: 14px;
  color: #4d5460;
  margin-right: 12px;
}

.model-container {
  position: relative;
  z-index: 4;
}

.status-point-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 4;
}

.status-point {
  width: 10px;
  height: 10px;
  flex-shrink: 0;
  margin-right: 10px;
  border-radius: 50%;
  background: #418fde;
}

.status-point.inactive {
  background: #c1c6c8;
}

.selected-field.selected {
  background: #dde5ed;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 3;
  pointer-events: none;
}

.tableview-main-right {
  background: #dde5ed;
  padding: 17px 20px 20px 20px;
  max-width: 420px;
  /*border-radius: 0 0 10px 0;*/
  overflow: auto;
}

.tableview-main-right-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.tableview-main-right-name {
  font-family: OpenSansBold, sans-serif;
  font-size: 20px;
  color: #005291;
  margin-right: 15px;
}

.tableview-main-right-status {
  width: 18px;
  height: 18px;
  margin-left: auto;
  flex-shrink: 0;
  border-radius: 50%;
  background: #418fde;
}

.tableview-main-right-status.inactive {
  background: #c1c6c8;
}

.tableview-main-right-info {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.tableview-main-right-model {
  font-size: 14px;
  color: #4d5460;
  margin-right: 10px;
}

.tableview-main-right-speed {
  background: #363636;
  border-radius: 10px;
  font-size: 14px;
  color: #ffffff;
  padding: 1px 10px;
}

.tableview-main-right-additional {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.tableview-main-right-additional-icon {
  margin-right: 10px;
}

.tableview-main-right-additional-label {
  margin-bottom: 3px;
  font-size: 12px;
  color: #9a9a9a;
}

.tableview-main-right-additional-value {
  font-size: 14px;
  font-family: OpenSansSemiBold, sans-serif;
  color: #4d5460;
}

.tableview-main-right-divider {
  height: 1px;
  background: #c1c6c8;
  margin-top: 15px;
  margin-bottom: 20px;
}

.button-update {
  border-radius: 10px;
  color: #ffffff;
  font-family: OpenSansRegular, sans-serif;
  font-size: 13px;
  background: #005291;
  width: 100%;
  height: 38px;
  outline: none;
  border: 0;
  padding: 0 12px;
  cursor: pointer;
  transition: all 0.4s;
}

.button-update:active {
  transform: scale(0.95);
}

.button-add {
  width: 100%;
  height: 38px;
  background: #005291;
  color: #ffffff;
  border: 0;
  border-radius: 10px;
  outline: none;
  cursor: pointer;
  font-family: OpenSansRegular, sans-serif;
  font-size: 13px;
  transition: all 0.4s;
}

.button-add:active {
  transform: scale(0.95);
}

.filter-column {
  display: flex;
  align-items: center;
  position: relative;
  font-family: OpenSansBold, sans-serif;
}

.filter-column svg {
  fill: #4d5460;
}

.filter-column.selected svg {
  fill: #005291;
}

.filter-icon {
  background: transparent;
  border: 0;
  outline: none;
  margin-right: 5px;
  cursor: pointer;
}

.filter-menu {
  position: absolute;
  width: 250px;
  top: 40px;
  left: 0;
  background: #ffffff;
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0px 0px 10px #dde5ed;
}

.ip-button {
  border-radius: 50%;
  background: transparent;
  border: 1px solid grey;
  color: grey;
  outline: none;
  flex-shrink: 0;
  margin-left: 5px;
  font-size: 13px;
  width: 30px;
  height: 30px;
  transition: all 0.4s;
}

.ip-button.active {
  border: 1px solid #005291;
  color: #005291;
}

.permanent-check {
  margin-top: 3px;
  font-size: 14px;
  color: #005291;
}

.permanent-check .form-check-input {
  width: 18px;
  height: 18px;
  margin-right: 6px;
  margin-top: 2px;
}

.permanent-check .form-check-input:checked {
  background-color: #2c5697;
  border-color: #2c5697;
}

.edit-modal {
  display: none;
}

/* < 1200 */
@media screen and (max-width: 1199px) {
  .tableview-main-right {
    display: none;
  }

  .edit-modal {
    display: initial;
  }

  .tableview-top-search label input {
    width: 300px;
  }
}

/* < 960 */
@media screen and (max-width: 959px) {
  /*верхняя строка*/
  .tableview-top-search.pc {
    display: none;
  }

  .tableview-top-search.mobile {
    display: block;
    padding: 0 20px 15px 20px;
  }

  .tableview-top-search label input {
    width: 100%;
  }

  /*таблица*/
  .tableview-main {
    display: flex;
    height: calc(100% - 121px);
  }
}

/* < 768 */
@media screen and (max-width: 767px) {
  .tableview-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px;
  }

  .tableview-top-search.mobile {
    display: block;
    padding: 0 15px 15px 15px;
  }

  .tableview-main-selected-actions-text {
    display: none;
  }

  .tableview-main-selected {
    padding: 20px 15px 20px 15px;
  }
}

/* < 620 */
@media screen and (max-width: 619px) {
  .tableview-top-count {
    font-size: 16px;
    margin-right: 0;
  }

  .button-add-transparent.mobile,
  .clear-filters.mobile {
    display: initial;
    padding: 0;
    width: 38px;
    height: 38px;
  }

  .button-add-transparent.mobile {
    border: 1px solid rgb(40, 189, 74);
  }

  .button-add-transparent.mobile svg {
    width: 20px;
    height: 20px;
  }

  .button-add-transparent.mobile svg {
    fill: rgb(40, 189, 74);
  }

  .clear-filters.mobile svg {
    width: 24px;
    height: 24px;
  }

  .clear-filters.mobile svg,
  .clear-filters.mobile svg path {
    fill: #ff7c7c;
  }

  .clear-filters.pc,
  .button-add-transparent.pc {
    display: none;
  }

  .delete-selected-btn {
    height: 38px;
    width: 38px;
    padding: 1px;
  }

  .delete-selected-btn span {
    display: none;
  }

  .delete-selected-btn svg {
    margin-right: 0;
  }

  .download-btn .pc {
    display: none;
  }

  .download-btn .mobile {
    display: initial;
  }

  .tableview-main-selected {
    padding: 15px;
  }

  .tableview-main-left {
    height: calc(100% - 110px);
  }

  .tableview-main-left.not-selected {
    height: calc(100% - 44px);
  }
}
</style>
